import { KazooError } from "@kazoohr/types";

/**
 * Given `subject`, typically a finite set of values, asserts that the subject
 * is not `toExclude` and renders the `subject` as `Exclude<subject, toExclude>`.
 */
export function assertIsNot<T, D extends T>(
  subject: T,
  toExclude: D,
  errorFactory: AssertIsNotErrorFactory<T, D> = (subject, toExclude) => {
    return new KazooError(
      "Invariance violation! Expected subject and toExclude to not match",
      {
        subject,
        toExclude,
      }
    );
  }
): asserts subject is Exclude<T, D> {
  if (subject === toExclude) {
    throw errorFactory(subject, toExclude);
  }
}

export type AssertIsNotErrorFactory<T, D extends T> = (
  subject: T,
  toExclude: D
) => KazooError;
